<template>
  <div class="w-full min-h-screen flex flex-col bg-gray-900">
    <MainNav />
    
    <main class="flex-1 flex items-center justify-center p-4 pt-20 md:pt-24 pb-8">
      <div class="max-w-md w-full bg-white rounded-lg shadow-xl p-8 text-center mx-auto">
        <!-- Success Icon -->
        <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
          <svg class="h-6 w-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
          </svg>
        </div>
        
        <!-- Success Message -->
        <h1 class="text-2xl font-bold text-gray-900 mb-2">決済完了</h1>
        <p class="text-gray-600 mb-6">
          ご注文ありがとうございます。決済が正常に完了しました。
        </p>
        
        <!-- Order Details -->
        <div class="bg-gray-50 rounded-lg p-4 mb-6">
          <h2 class="font-semibold text-gray-900 mb-2">注文詳細</h2>
          <p class="text-sm text-gray-600">
            確認メールをお送りしました。商品は48時間以内に発送いたします。
          </p>
        </div>
        
        <!-- Action Buttons -->
        <div class="space-y-3">
          <router-link 
            to="/jp" 
            class="block w-full bg-blue-600 text-white py-3 px-4 rounded-lg hover:bg-blue-700 transition-colors font-medium"
          >
            商品ページに戻る
          </router-link>
          
          <router-link 
            to="/" 
            class="block w-full bg-gray-200 text-gray-800 py-3 px-4 rounded-lg hover:bg-gray-300 transition-colors font-medium"
          >
            ホームに戻る
          </router-link>
        </div>
        
        <!-- Legal Notice -->
        <div class="mt-6 pt-6 border-t border-gray-200">
          <p class="text-xs text-gray-500">
            20歳未満の者の飲酒は法律で禁止されています。<br>
            20歳未満の者に対しては酒類を販売しません。
          </p>
        </div>
      </div>
    </main>
    
    <Footer />
  </div>
</template>

<script setup>
import MainNav from '../components/MainNav.vue';
import Footer from '../components/Footer.vue';
import { useCart } from '../composables/useCart';
import { onMounted } from 'vue';

const { clearCart } = useCart();

// Clear cart on successful payment
onMounted(() => {
  clearCart();
});
</script>
